/**
 * `invitations` — accès (base plateforme, 4.1).
 */
import { z } from 'zod';
import { droitsFinsSchema, porteeSchema, roleSchema } from '../permissions/roles.js';
import { CHAMPS_DOCUMENT, emailSchema, idSchema, withAudit } from './commun.js';
export const ETATS_INVITATION = ['envoyee', 'acceptee', 'expiree', 'revoquee'];
export const etatInvitationSchema = z.enum(ETATS_INVITATION);
export const invitationSchema = withAudit(z.object({
    _id: idSchema,
    email: emailSchema,
    portee: porteeSchema,
    galerieId: idSchema.optional(),
    groupeId: idSchema.optional(),
    role: roleSchema,
    droits: droitsFinsSchema,
    jetonHash: z.string(),
    expireLe: z.date(),
    etat: etatInvitationSchema.default('envoyee'),
    accepteeLe: z.date().optional(),
}));
export const invitationCreationSchema = invitationSchema.omit({
    ...CHAMPS_DOCUMENT,
    jetonHash: true,
    accepteeLe: true,
    etat: true,
});
export const invitationMiseAJourSchema = invitationCreationSchema
    .omit({ email: true, portee: true })
    .partial();
//# sourceMappingURL=invitations.js.map